import React from "react";
import axios from "axios";
import Chart from "react-google-charts";
import ReportsError from './ReportsError';
import { getFromLocalStorage } from './Utilities';

class ReportsCountryActivityTableBody extends React.Component {
    render() {
        const countries = this.props.countries;

        if (countries.length > 0) {
            return (
                <tbody>
                    {countries.map(country => (
                        <tr key={country.Country}>
                            <td>{country.CountryName}</td>
                            <td>{country.Actions}</td>
                            <td>{country.Members}</td>
                        </tr>
                    ))}
                </tbody>
            );
        }

        return null;
    }
}

class ReportsCountryActivityChart extends React.Component {
    render() {
        const countries = this.props.countries;
        const graphData = [["Country", "Actions"]];

        countries.forEach(country => {
            graphData.push([country.CountryName, parseInt(country.Actions)]);
        });

        const options = {
            colors: ['#CCC', '#44BEA6']
        };

        return (
            <Chart
                chartType="GeoChart"
                width="100%"
                height="600px"
                data={graphData}
                options={options}
            />
        );
    }
}

class ReportsCountryActivity extends React.Component {
    constructor(props) {
        super(props);

        let filters = getFromLocalStorage("report_data");
        if (typeof filters === "string") {
            filters = JSON.parse(filters);
        }

        const brand = filters?.ChooseBrands?.[0];
        const endpoint = brand
            ? `brand/${brand.ID}/stats/location`
            : "brand/<UmbrellaID>/stats/location";

        this.state = {
            url: `react/process?endpoint=${endpoint}&hourly_cutoff=0&turnoffdebug=1&includeonetime=1`,
            countries: [],
            isLoading: true,
            error: null
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        axios.get(this.state.url)
            .then(response => this.formatData(response.data))
            .catch(err => {
                console.error("Fetch error:", err);
                this.setState({ isLoading: false, error: "Failed to load data" });
            });
    }

    formatData(data) {
        let countries = data.Countries || [];
        const error = data?.error || null;

        countries = countries.sort((a, b) => b.Actions - a.Actions);

        this.setState({ countries, isLoading: false, error: error?.message });
    }

    render() {
        const { isLoading, countries, error } = this.state;
        const currentView = this.props.view;

        if (isLoading) {
            return (
                <div className="row">
                    <div className="col-md-4"></div>
                    <div className="loading col-md-4">
                        <div className="react-loading big" style={this.props.loaderStyle}></div>
                    </div>
                    <div className="col-md-4"></div>
                </div>
            );
        }

        if (countries.length === 0) {
            return (
                <ReportsError error={error} table="false" type="activities" />
            );
        }

        return currentView === "graph"
            ? this.renderGraph()
            : this.renderTable();
    }

    renderTable() {
        return (
            <div className="feed-countrylist">
                <table id="basic-datatable" className="table dt-responsive nowrap w-100">
                    <thead>
                        <tr>
                            <th>Country</th>
                            <th>Actions</th>
                            <th>Members</th>
                        </tr>
                    </thead>
                    <ReportsCountryActivityTableBody
                        countries={this.state.countries}
                    />
                </table>
            </div>
        );
    }

    renderGraph() {
        return (
            <div className="chart-countrylist">
                <ReportsCountryActivityChart
                    countries={this.state.countries}
                />
            </div>
        );
    }
}

ReportsCountryActivity.defaultProps = {
    loaderStyle: {
        height: "200px"
    }
};

export default ReportsCountryActivity;
